import React from 'react';
import "./Footer.css";
import LinkedIn from './../../images/linkedin.svg';
import Github from './../../images/github.svg';
import Instagram from './../../images/instagram.svg';


const Footer = () => {
    return(
        <footer id="footer" class="footer">
            <a href="mailto:t.huynh3861@gmail.com" class="footer-link">t.huynh3861@gmail.com</a>
            <u1 class="social-list">
                <li class="social-list__item">
                    <a href="https://www.linkedin.com/in/tam-n-huynh/"><img class="logos" src={LinkedIn}/></a>
                </li>

                <li class="social-list__item">
                    <a href="https://github.com/tam-n-huynh"><img class="logos" src={Github}/></a>
                </li>

                <li class="social-list__item">
                    <a href="https://www.instagram.com/tamnhuynh_/"><img class="logos" src={Instagram}/></a>
                </li>

                

            </u1>
        </footer>
    )
}

export default Footer;